import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { ImageState } from '../../../../ui/gzImageRepo/types';
import { FontSizes } from '../../../../types/common/types';

export const templateEasmScanConfiguration = document.createElement('template');

templateEasmScanConfiguration.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class="scheduler-container">
      <gz-easm-scan-configuration-scheduler>
      </gz-easm-scan-configuration-scheduler>
      <gz-text fontSize="${FontSizes.HEADING_6}" id="legal-info-text"></gz-text>
    </div>
    <div class="assets-to-scan">
      <gz-tab-group id="scan-tab-group" class="assets-to-scan-tab-group">
        <gz-tab id="add-asset-to-scan-tab" style="position: static;"></gz-tab>
        <gz-tab id="exclude-asset-from-scan-tab" style="position: static;"></gz-tab>
      </gz-tab-group>

      <div class="content">
        <gz-easm-scan-configuration-item-form></gz-easm-scan-configuration-item-form>
        <gz-easm-scan-configuration-asset-grid class="hidden"></gz-easm-scan-configuration-asset-grid>
      </div>

      <div id="no-results" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.START}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="no-results-message"></gz-title>
          <gz-text id="no-results-additional-text" fontSize="14" lineHeight="2"></gz-text>
        </gz-image-repo>
      </div>
    </div>
  </div>
`;
